import React, { createContext } from 'react';
import { Station } from '../../../../../../types/types';

export type GasStationContextType = {
    label: string
    value: number
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const GasStationContext = createContext<[Station[], React.Dispatch<React.SetStateAction<Station[]>>]>([[], () => { }]);
